<template>
  <div></div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'normal',
    },
    data: {
      type: Array,
      default: () => [],
    },
    pager: {
      type: Object,
      default: null
    },
    error: {
      type: Error,
      default: null,
    },
  },
}
</script>

<style>

</style>